import { useOnChangeRef } from '@/features/form/hooks/useOnChangeRef'
import { OnChange } from '@/features/form/types'
import { useCallback } from 'react'

export const useUpdateRemovableIngredient = (
    isRemoved: boolean | undefined,
    onChange: OnChange
) => {
    const onChangeRef = useOnChangeRef(onChange)

    return useCallback(() => onChangeRef.current(!isRemoved), [isRemoved, onChangeRef])
}
